import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Paper, Typography, TextField, Button } from '@mui/material';
import './detailTalent.css';

const NotesTab = ({ talentId: propTalentId, origine }) => {
  const params = useParams();
  const talentId = propTalentId || params.talentId;
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [note, setNote] = useState('');
  const [notes, setNotes] = useState([]);

  const isCandidat = origine === 'Candidat';

  useEffect(() => {
    if (!talentId) return;

    const fetchNotes = async () => {
      try {
        const endpoint = isCandidat 
          ? `${API_BASE}/api/admin/candidat/${talentId}` 
          : `${API_BASE}/api/recruteur/talent/${talentId}`;

        const res = await axios.get(endpoint);
        setNotes(res.data.note || []);
      } catch (err) {
        console.error("Erreur lors du chargement des notes :", err);
      }
    };

    fetchNotes();
  }, [talentId, isCandidat]);

  const handleAddNote = async () => {
    if (!note.trim()) return;

    try {
      const endpoint = isCandidat 
        ? `${API_BASE}/api/admin/candidat/${talentId}/note`
        : `${API_BASE}/api/recruteur/talent/${talentId}/note`;

      const res = await axios.put(endpoint, { note: note.trim() });
      setNotes(res.data.note || []);
      setNote('');
    } catch (err) {
      console.error("Erreur lors de l'ajout de la note :", err);
    }
  };

  return (
    <Paper elevation={3} className="notes-container">
      <Typography variant="h6" gutterBottom>Ajouter une note</Typography>
      <TextField
        multiline
        minRows={2}
        fullWidth
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Écrivez une note..."
        className="note-textarea"
      />
      <Button variant="contained" onClick={handleAddNote} sx={{ mt: 2 }}>
        Ajouter
      </Button>
      {notes.map((n, i) => (
        <Paper key={i} className="note-entry">
          <Typography variant="caption">{new Date().toLocaleString()}</Typography>
          <Typography>{n}</Typography>
        </Paper>
      ))}
    </Paper>
  );
};


export default NotesTab;
